import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-794030b0")
const _hoisted_1 = { class: "rounded-icon-btn" }
_popScopeId()

import { computed, ref } from "vue";
import { IconSearch } from "@/components/icons";
import { IconEarth } from "@/components/icons";


export default /*#__PURE__*/_defineComponent({
  props: {
  icon: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props
_useCssVars(_ctx => ({
  "13a45878": (color.value)
}))

const color = ref("#fff");



const IconComponent = computed(() => {
  switch (props.icon) {
    case "search":
      color.value = "#FF5A5F";
      return IconSearch;
    case "earth":
      return IconEarth;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createBlock(_KeepAlive, null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(IconComponent))))
    ], 1024))
  ]))
}
}

})